export default "__VITE_ASSET__B7Bils$I__"